import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonButton } from './Button.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonButton({ prefix }));
}
